import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LeavesRequestHelper  {
    _originalTypeClassName = "zSHR.BO.LeavesRequestHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LeavesRequestHelper.translate = translateService;
}
this.LeavesRequestHelperKey = null;
this._key = this.LeavesRequestHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _LeavesRequestHelperKey:any;
get LeavesRequestHelperKey(): any {
    return this._LeavesRequestHelperKey;
  }
set LeavesRequestHelperKey(value: any) {
    this._LeavesRequestHelperKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.LeavesRequestHelperKey == null || $this.LeavesRequestHelperKey == 0;
            }


}